<div (keydown.enter)="$event.preventDefault()" class="date-input-form">
<!--    <ig-row *ngIf="!frequency||frequency==='custom'" class="time-input">-->
    <ig-row class="time-input">
        <ig-col [xs]="6" [md]="3" [lg]="3">
            <!--[max]="endDatePrivate"-->
            <ig-date-field label="From"
                           type="date"
                           [disabled]="disabled"
                           [(ngModel)]="startDatePrivate"
                           (change)="dateChange($event, 'start')"
                           [formControl]="dateTimeForm.get('time')"
                           [min]="today">
            </ig-date-field>
        </ig-col>
        <ig-col [xs]="6" [md]="3" [lg]="3">
            <mat-form-field timeselect>
                <mat-select #startSelect [disabled]="disabled" (change)="setTime('start')"
                            [(value)]="startTime">
                    <mat-option *ngIf="allowNoTime" value="no-time">{{noTimeTip}}</mat-option>
                    <mat-option *ngFor="let option of timeOptionsForStart" [value]="option.value">{{option.text}}
                    </mat-option>

                </mat-select>
            </mat-form-field>
        </ig-col>
        <ig-col [xs]="6" [md]="3" [lg]="3" class="to">
            <!--[min]="startDatePrivate"-->
            <ig-date-field label="To"
                           type="date"
                           [(ngModel)]="endDatePrivate"
                           [disabled]="disabled"
                           (change)="dateChange($event, 'end')"
                           [formControl]="dateTimeForm.get('time2')"
                           [min]="today">
            </ig-date-field>
        </ig-col>
        <ig-col [xs]="6" [md]="3" [lg]="3">
            <mat-form-field timeselect>
                <mat-select #endSelect [disabled]="disabled" (change)="setTime('end')" [(value)]="endTime">
                    <mat-option *ngIf="allowNoTime" value="no-time">{{noTimeTip}}</mat-option>
                    <mat-option *ngFor="let option of timeOptionsForEnd" [value]="option.value">{{option.text}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ig-col>
    </ig-row>

<!--    <div *ngIf="frequency!=='custom'" class="time-input">-->
<!--        <ig-row>-->
<!--            <ig-col [xs]="5">-->
<!--                <ig-date-field label="From"-->
<!--                               type="date"-->
<!--                               [disabled]="disabled"-->
<!--                               [(ngModel)]="startDatePrivate"-->
<!--                               (change)="dateChange($event, 'start')"-->
<!--                               [formControl]="dateTimeForm.get('time')"-->
<!--                               [min]="today">-->
<!--                </ig-date-field>-->
<!--            </ig-col>-->
<!--            <ig-col [xs]="5">-->
<!--                <ig-date-field label="To"-->
<!--                               type="date"-->
<!--                               [(ngModel)]="endDatePrivate"-->
<!--                               [disabled]="disabled"-->
<!--                               (change)="dateChange($event, 'end')"-->
<!--                               [formControl]="dateTimeForm.get('time2')"-->
<!--                               [min]="today">-->
<!--                </ig-date-field>-->
<!--            </ig-col>-->
<!--        </ig-row>-->
<!--        <div class="flex">-->
<!--            <div style="width: 39%">-->
<!--                <mat-form-field timeselect>-->
<!--                    <mat-select #startSelect [disabled]="disabled" (change)="setTime('start')"-->
<!--                                [(value)]="startTime">-->
<!--                        <mat-option *ngIf="allowNoTime" value="no-time">{{noTimeTip}}</mat-option>-->
<!--                        <mat-option *ngFor="let option of timeOptionsForStart" [value]="option.value">{{option.text}}-->
<!--                        </mat-option>-->

<!--                    </mat-select>-->
<!--                </mat-form-field>-->
<!--            </div>-->
<!--            <div style="width: 5%;line-height: 43px;text-align: center">-->
<!--                - -->
<!--            </div>-->
<!--            <div style="width: 39%">-->
<!--                <mat-form-field timeselect>-->
<!--                    <mat-select #endSelect [disabled]="disabled" (change)="setTime('end')" [(value)]="endTime">-->
<!--                        <mat-option *ngIf="allowNoTime" value="no-time">{{noTimeTip}}</mat-option>-->
<!--                        <mat-option *ngFor="let option of timeOptionsForEnd" [value]="option.value">{{option.text}}-->
<!--                        </mat-option>-->
<!--                    </mat-select>-->
<!--                </mat-form-field>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/datetime.input/datetime.input.component.html